module.exports = __webpack_public_path__ + "static/img/5510848f6bdac5af3d2cde8693b8e363.b96223f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5510848f6bdac5af3d2cde8693b8e363.png
// module id = 3/1P
// module chunks = 73